export default {
      id: "ic_highlight_tab_active-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_highlight_tab_active-usage",
      toString: function () {
        return this.url;
      }
    }